<template>
  <bimini-default-section class="menu--section-bimini_dessert" :menu="menu" :section="section"
                          menu-item-tag-location="before-title" is-title-buffer-visible
                          ></bimini-default-section>
</template>

<script lang="ts">
/**
 * Special component for Bimini dessert section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2022-10-17 (1.0.0) (jhoward)
 *      - Copy <Bimini_dessert> component from <Romanza_defaultSection>.
 *
 *    2023-04-17 (1.1.0) (jhoward)
 *      - Refactor <Bimini_dessert> to use TypeScript.
 *      - <Bimini_dessert> section prop is required.
 *      - Refactor <Bimini_dessert> to use helper functions for computed properties.
 *
 *  2023-08-23 (1.2.0) (jhoward)
 *    - Use <menu-version> in <Bimini_dessert>.
 *
 *  2025-02-11 (1.3.0) (jhoward)
 *    - Add <menu-schedules> to the <Bimini_dessert> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <bimini-default-section> in <bimini_dessert>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import BiminiDefaultSection from "./Bimini_defaultSection.vue";

export default defineComponent({
  components: {
    BiminiDefaultSection,
  },
  name: "Bimini_dessert",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  }
})
</script>

<style scoped>
.menu--section-bimini_dessert {
  font-size: 0.9em;
  margin: 0 auto;
  max-width: 80%;
  padding-top: 0.5em;
}

.visual_menu--container-landscape .menu--section-bimini_dessert {
  padding-top: 0.5em;
}

.visual_menu--section.menu--section-bimini_dessert:deep(h2) {
  margin-left: -6em;
  width: calc(100% + 12em);
}





.menu--section-bimini_dessert:deep(.menu--section_subgroup_title) {
  color: #3e2603;
  margin: 2rem auto 0.2em auto;
  padding: 0;
  text-align: center;
}

@media (prefers-contrast: more) {
  .menu--section-bimini_dessert:deep(.menu--section_subgroup_title) {
    color: #000;
  }
}

/*.menu--section-bimini_dessert:deep(.menu--section_title),*/
.menu--section-bimini_dessert:deep(.menu--section_subgroup_title span:first-child) {
  font-family: bodoni-urw, serif;
  font-weight: 500;
  font-style: normal;
  font-variant: small-caps;
  letter-spacing: 0.05em;
  font-size: 2em;
}

/*.menu--section-bimini_dessert:deep(.menu--section_subtitle) {
  margin-top: -1em;
  font-size: 1em;
  font-weight: 400;
  margin-bottom: 0.4em;
}*/

.menu--section-bimini_dessert:deep(.menu--section_subgroup_title) {
  text-align: left;
  position: relative;
}

.menu--section-bimini_dessert.menu--section-group_by_price:deep(.menu--section_subgroup_title) {
  border-bottom: none;
  color: #000000;
  font-size: 0.8em;
}

.menu--section-bimini_dessert:deep(.menu--section_subgroup_title) {
  align-items: end;
}

.menu--section-bimini_dessert:deep(.menu--section_subgroup_title span:not(:first-child)) {
  text-align: right;
  color: #000000;
  padding-bottom: 0.1em;
}

.menu--section-bimini_dessert:deep(.visual_menu--page_section-bottom) {
  text-align: center;
}








.menu--section-bimini_dessert:deep(.menu--item) {
  text-align: center;
  display: block;
}

.menu--section-bimini_dessert:deep(.menu--item + .menu--item) {
  margin-top: 1em;
}

.menu--section-bimini_dessert:deep(.menu--item_price) {
  margin-left: 0.2em;
}

.menu--section-bimini_dessert:deep(.menu--item_price-own_line) {
  display: block;
  margin-left: 0;
}

.menu--section-bimini_dessert:deep(.menu--item_description) {
  margin-top: 0;
  font-size: 0.9em;
}

.menu--section-bimini_dessert:deep(.menu--item_subtitle) {
  display: block;
  font-size: 0.7em;
}

.menu--section-bimini_dessert:deep(h3) {
  font-size: 1.2em;
  font-weight: bold;
}

.menu--section-bimini_dessert:deep(.visual_menu--page_section-top),
.menu--section-bimini_dessert:deep(.visual_menu--page_section-bottom ){
  text-align: center;
  padding-bottom: 1.5em;
  margin-top: -1.2em;
}




.menu--section-bimini_dessert:deep(.menu--section_subgroup_title ){
  text-align: center;
  color: #c15e21;
  font-size: 1.05em;
}

.menu--section-bimini_dessert:deep(.menu--section_group_title:not(:first-child)),
.menu--section-bimini_dessert:deep(.menu--item_subgroup:not(:first-child) .menu--section_subgroup_title ){
  margin-top: 1em;
}
</style>